var map = {
	"./BackgroundWithFrame-Ruffel-Overlay-AE.mp4": 4870,
	"./Halo-Overlays-AE.mp4": 6564,
	"./Kinoq-Overlay.mp4": 1166,
	"./Ruffel-Overlay-SS-V2-AE.mp4": 3042
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5495;